import React from "react";
import { useTranslation } from "react-i18next";
import { PlannerTitleRow } from "./PlannerTitleRow";

const TRACK_TITLE_KEYS = {
  training: "annualPlanner.trainingPhase",
  nutrition: "annualPlanner.nutritionPhase",
};

// Full-width title bar for a phase track (Training/Nutrition) - split out of
// PhaseRowHeader.js so it can span the whole grid (label column + every
// month), not just the narrow label column its phase-name rows still live
// in. Wraps PlannerTitleRow.js (the generic version Notes/Milestones/Tracked
// Results use directly) just to resolve the per-track title key + count.
export const PhaseTrackTitle = ({
  phases,
  track = "training",
  isCollapsed = false,
  onToggleCollapse,
}) => {
  const { t } = useTranslation("athlete-portal");

  return (
    <PlannerTitleRow
      title={t(TRACK_TITLE_KEYS[track])}
      // Hidden for now, not deleted - the PRD doesn't specify this badge
      // (only mentions "discipline" re: future phase-name preset packs,
      // section 7.2/12 - see ~/Downloads/1784748747555.docx), and there's
      // no real per-client "discipline" field to source it from yet (the
      // only thing close is DemoStylePicker's one-shot demo-seed choice,
      // not a persisted client attribute). Uncomment once that's decided.
      // See ~/.claude/plans/periodization-calendar-view-redesign.md.
      // badge={<span className="phase-track-badge">Strongman</span>}
      count={t("annualPlanner.phaseCount", { count: phases?.length || 0 })}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    />
  );
};
